import { useState } from 'react';

import { getApiAccessToken, setApiAccessToken } from '@client/api';

import { DebugButton } from './debug-button.component';
import { DebugPre } from './debug-pre.component';

export function DebugApiToken() {

  const [apiAccessTokenState, setApiAccessTokenState] = useState(getApiAccessToken());

  const handleClearApiAccessToken = () => {
    setApiAccessToken(null);
    setApiAccessTokenState(getApiAccessToken());
  }

  return (
    <article className="space-y-2">
      <div>
        Current API Access Token:
      </div>
      <DebugPre onClick={() => console.log(apiAccessTokenState)}>
        {apiAccessTokenState}
      </DebugPre>

      <DebugButton onClick={handleClearApiAccessToken}>
        Clear Token
      </DebugButton>
    </article>
  )

}
